import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import { AXIOS_REQUEST_TIMEOUT } from './config/constants';

const getAxiosURL = (config: AxiosRequestConfig): string | null => {
  if (!config.baseURL && !config.url) {
    return null;
  }

  return (config.baseURL ? config.baseURL : '') + (config.url ? config.url : '');
};

const getAxiosMethod = (config: AxiosRequestConfig): string | null => {
  return config.method ? config.method.toUpperCase() : null;
};

const getAxiosBody = (response: AxiosResponse): any | null  => {
  return Object.keys(response.data).length > 0 ? response.data : null;
};

axios.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    config.timeout = AXIOS_REQUEST_TIMEOUT;

    if (process.env.NODE_ENV !== 'production') {
      const url = getAxiosURL(config);
      const method = getAxiosMethod(config);

      console.log(method, url);
    }

    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response: AxiosResponse) => {
    if (process.env.NODE_ENV !== 'production') {
      const url = getAxiosURL(response.config);
      const method = getAxiosMethod(response.config);
      const body = getAxiosBody(response);

      if (body) {
        console.log(method, url, '\n', response.status, '\n', body);
      } else {
        console.log(method, url, '\n', response.status);
      }
    }

    return response;
  },
  (error: AxiosError) => {
    const url = error.response ? getAxiosURL(error.response.config) : null;
    const method = error.response ? getAxiosMethod(error.response.config) : null;
    const body = error.response ? getAxiosBody(error.response) : null;

    if (body) {
      console.log(method, url, '\n', error.response?.status, '\n', body);
    } else {
      console.log(method, url, '\n', error.response?.status);
    }

    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
